export const scrollToSignup = () => {
    const el = document.getElementById("zapis");
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -70, duration: 1.4 });
    } else {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
};
